import {appAPI} from "../../../api";
import {
    IBoard,
    ICar,
    ICarColor,
    ICarEvent,
    ICarWithEvents,
    IMoveInput,
    MilestoneStatus,
    DONE_PAGE,
    EVENTS_PAGE,
} from "../model/types";

/** Курсор «старше чем»: время и id последней полученной строки. */
export interface ICursor {
    before: string;
    before_id: string;
}

/**
 * HTTP доски (src/car/*.controller.ts, src/car_color/*.controller.ts).
 * Ошибки не перехватываются: текст берётся из `message` ответа в thunk'ах.
 */
export const boardAPI = {
    getBoard: async (): Promise<IBoard> => (await appAPI.get("/board")).data,
    getDone: async (cursor: ICursor): Promise<ICar[]> =>
        (await appAPI.get("/cars/done", {params: {...cursor, limit: DONE_PAGE}})).data,
    /** `mine` — только свои события (S18): `?mine=1`. */
    getEvents: async (cursor?: ICursor, mine = false): Promise<ICarEvent[]> =>
        (await appAPI.get("/events", {params: {...cursor, limit: EVENTS_PAGE, ...(mine && {mine: 1})}})).data,
    getCar: async (id: string): Promise<ICarWithEvents> => (await appAPI.get(`/cars/${id}`)).data,

    createCar: async (vin: string, color_id: string): Promise<ICar> =>
        (await appAPI.post("/cars", {vin, color_id})).data,
    updateCar: async (
        id: string,
        dto: {vin?: string; color_id?: string | null; stage_note?: string | null},
    ): Promise<ICar> => (await appAPI.patch(`/cars/${id}`, dto)).data,
    deleteCar: async (id: string): Promise<{id: string}> => (await appAPI.delete(`/cars/${id}`)).data,

    move: async (id: string, dto: IMoveInput): Promise<ICar> =>
        (await appAPI.post(`/cars/${id}/move`, dto)).data,
    take: async (id: string): Promise<ICar> => (await appAPI.post(`/cars/${id}/take`)).data,
    release: async (id: string): Promise<ICar> => (await appAPI.post(`/cars/${id}/release`)).data,
    /** «Стенды» (S18): в ремзоне / на стендах. */
    setAtStands: async (id: string, at_stands: boolean): Promise<ICar> =>
        (await appAPI.post(`/cars/${id}/stands`, {at_stands})).data,
    /** «Уехала» (S17.1): машина уходит с доски в Стату. */
    ship: async (id: string): Promise<{id: string}> => (await appAPI.post(`/cars/${id}/ship`)).data,
    /** «Вернуть на доску» (S17.1). */
    unship: async (id: string): Promise<ICar> => (await appAPI.post(`/cars/${id}/unship`)).data,

    setMilestone: async (id: string, kind: string, status: MilestoneStatus, remark?: string | null): Promise<ICar> =>
        (await appAPI.put(`/cars/${id}/milestones/${kind}`, {status, remark})).data,
    clearMilestone: async (id: string, kind: string): Promise<ICar> =>
        (await appAPI.delete(`/cars/${id}/milestones/${kind}`)).data,

    raiseAlert: async (id: string, reason: string): Promise<ICar> =>
        (await appAPI.post(`/cars/${id}/alert`, {reason})).data,
    takeAlert: async (id: string): Promise<ICar> => (await appAPI.post(`/cars/${id}/alert/take`)).data,
    releaseAlert: async (id: string): Promise<ICar> => (await appAPI.post(`/cars/${id}/alert/release`)).data,
    resolveAlert: async (id: string, comment?: string | null): Promise<ICar> =>
        (await appAPI.post(`/cars/${id}/alert/resolve`, {comment})).data,

    createColor: async (name: string, image_url: string | null): Promise<ICarColor> =>
        (await appAPI.post("/car-colors", {name, image_url})).data,
};
